module.exports = __webpack_public_path__ + "img/shipo-map-vessel-new.f3d10281.svg";